import { useState } from 'react';
import { postContact } from '../api/customer';
import '../styles/contact.css';

/* ── Icons ───────────────────────────────────────────────────── */
function IconWA() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
      <path d="M12 0C5.373 0 0 5.373 0 12c0 2.115.548 4.099 1.508 5.822L0 24l6.335-1.508A11.952 11.952 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.818a9.818 9.818 0 0 1-5.003-1.372l-.359-.214-3.727.977.995-3.635-.234-.373A9.818 9.818 0 1 1 12 21.818z" />
    </svg>
  );
}

function IconIG() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  );
}

function IconTT() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.77 1.53V6.75a4.85 4.85 0 0 1-1-.06z" />
    </svg>
  );
}

function IconPIN() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 0C5.373 0 0 5.373 0 12c0 5.084 3.163 9.426 7.627 11.174-.105-.949-.2-2.405.042-3.441.218-.937 1.407-5.965 1.407-5.965s-.359-.719-.359-1.782c0-1.668.967-2.914 2.171-2.914 1.023 0 1.518.769 1.518 1.69 0 1.029-.655 2.568-.994 3.995-.283 1.194.599 2.169 1.777 2.169 2.133 0 3.772-2.249 3.772-5.495 0-2.873-2.064-4.882-5.012-4.882-3.414 0-5.418 2.561-5.418 5.207 0 1.031.397 2.138.893 2.738a.36.36 0 0 1 .083.345l-.333 1.36c-.053.22-.174.267-.402.161-1.499-.698-2.436-2.889-2.436-4.649 0-3.785 2.75-7.262 7.929-7.262 4.163 0 7.398 2.967 7.398 6.931 0 4.136-2.607 7.464-6.227 7.464-1.216 0-2.359-.632-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0z" />
    </svg>
  );
}

function IconArrow() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
      <path d="M5 12h14M12 5l7 7-7 7" />
    </svg>
  );
}

function IconRefresh() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden="true">
      <path d="M23 4v6h-6" />
      <path d="M1 20v-6h6" />
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15" />
    </svg>
  );
}

function IconCheck() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

/* ── Captcha helpers ─────────────────────────────────────────── */
function makeCaptcha() {
  return {
    a: Math.floor(Math.random() * 15) + 1,
    b: Math.floor(Math.random() * 15) + 1,
  };
}

/* ═══════════════════════════════════════════════════════════════
   ContactPage
═══════════════════════════════════════════════════════════════ */
export function ContactPage() {
  const [captcha, setCaptcha] = useState(makeCaptcha);
  const [captchaVal, setCaptchaVal] = useState('');
  const [captchaError, setCaptchaError] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [apiSubmitting, setApiSubmitting] = useState(false);
  const [apiError, setApiError] = useState('');

  const refreshCaptcha = () => {
    setCaptcha(makeCaptcha());
    setCaptchaVal('');
    setCaptchaError(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError('');
    if (parseInt(captchaVal, 10) !== captcha.a + captcha.b) {
      setCaptchaError(true);
      refreshCaptcha();
      return;
    }
    setApiSubmitting(true);
    try {
      await postContact({
        name: name.trim(),
        email: email.trim(),
        message: message.trim(),
        subject: 'Website contact form',
      });
      setSubmitted(true);
      setName('');
      setEmail('');
      setMessage('');
    } catch (err) {
      setApiError(err instanceof Error ? err.message : 'Could not send message.');
      refreshCaptcha();
    } finally {
      setApiSubmitting(false);
    }
  };

  return (
    <main className="elenardContact">

      {/* ── Dark hero ──────────────────────────────────────────── */}
      <div className="elenardContact__hero">
        <div className="container">
          <div className="elenardContact__heroInner">
            <div className="elenardContact__badge">
              <span>✦</span>
              <span>Contact</span>
            </div>
            <h1 className="elenardContact__title">Let's Talk</h1>
            <p className="elenardContact__lead">
              Have questions, suggestions, or just want to say hello? Fill in the form and we'll
              get back to you within 24 hours.
            </p>
          </div>
        </div>
      </div>

      {/* ── Grid content ───────────────────────────────────────── */}
      <div className="elenardContact__content">
        <div className="container">
          <div className="elenardContact__grid">

            {/* Form panel */}
            <section className="elenardContact__panel" aria-label="Contact form">
              {submitted ? (
                /* Success state */
                <div className="elenardContact__success">
                  <div className="elenardContact__successIcon">
                    <IconCheck />
                  </div>
                  <h3 className="elenardContact__successTitle">Message sent!</h3>
                  <p className="elenardContact__successText">
                    Thank you for reaching out. We'll reply within 24 hours — check your spam
                    folder if you don't hear back.
                  </p>
                  <button
                    className="elenardContact__successBtn"
                    type="button"
                    onClick={() => {
                      setSubmitted(false);
                      refreshCaptcha();
                      setApiError('');
                    }}
                  >
                    Send another message
                  </button>
                </div>
              ) : (
                /* Contact form */
                <form className="elenardContact__form" onSubmit={handleSubmit}>
                  {apiError ? (
                    <p className="elenardContact__captchaError" role="alert" style={{ marginBottom: 12 }}>
                      {apiError}
                    </p>
                  ) : null}
                  <div className="elenardContact__field">
                    <label className="elenardContact__labelText" htmlFor="elenard_name">
                      Full Name<span className="elenardContact__req">*</span>
                    </label>
                    <input
                      id="elenard_name"
                      className="elenardContact__input"
                      required
                      autoComplete="name"
                      placeholder="Your full name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>

                  <div className="elenardContact__field">
                    <label className="elenardContact__labelText" htmlFor="elenard_email">
                      Email Address<span className="elenardContact__req">*</span>
                    </label>
                    <input
                      id="elenard_email"
                      className="elenardContact__input"
                      type="email"
                      required
                      autoComplete="email"
                      placeholder="you@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="elenardContact__field">
                    <label className="elenardContact__labelText" htmlFor="elenard_message">
                      Message<span className="elenardContact__req">*</span>
                    </label>
                    <textarea
                      id="elenard_message"
                      className="elenardContact__textarea"
                      required
                      rows={6}
                      placeholder="Tell us what's on your mind..."
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </div>

                  {/* Number captcha */}
                  <div className="elenardContact__field">
                    <label className="elenardContact__labelText" htmlFor="elenard_captcha">
                      Verification — solve to continue
                      <span className="elenardContact__req">*</span>
                    </label>
                    <div className="elenardContact__captchaRow">
                      <div className="elenardContact__captchaQuestion" aria-label={`What is ${captcha.a} plus ${captcha.b}`}>
                        {captcha.a} + {captcha.b} =
                      </div>
                      <input
                        id="elenard_captcha"
                        className={`elenardContact__captchaInput${captchaError ? ' elenardContact__captchaInput--error' : ''}`}
                        type="number"
                        inputMode="numeric"
                        value={captchaVal}
                        onChange={(e) => {
                          setCaptchaVal(e.target.value);
                          setCaptchaError(false);
                        }}
                        required
                        placeholder="?"
                        autoComplete="off"
                        aria-label="Your answer"
                      />
                      <button
                        type="button"
                        className="elenardContact__captchaRefresh"
                        onClick={refreshCaptcha}
                        aria-label="Generate new question"
                      >
                        <IconRefresh />
                      </button>
                    </div>
                    {captchaError && (
                      <p className="elenardContact__captchaError" role="alert">
                        Incorrect — try the new question.
                      </p>
                    )}
                  </div>

                  <button className="elenardContact__btn" type="submit" disabled={apiSubmitting}>
                    {apiSubmitting ? 'Sending…' : 'Send Message'}
                    <IconArrow />
                  </button>
                </form>
              )}
            </section>

            {/* Info panel */}
            <aside className="elenardContact__panel elenardContact__info" aria-label="Contact details">
              <p className="elenardContact__hint">
                We'll reply as soon as we can. If you don't see a reply within 24 hours, please
                check your spam folder.
              </p>

              <div className="elenardContact__block">
                <h2 className="elenardContact__copyTitle">Direct Contact</h2>
                <a
                  className="elenardContact__contactRow"
                  href="https://wa.me/60146227288"
                  target="_blank"
                  rel="noreferrer"
                >
                  <div className="elenardContact__iconWrap elenardContact__iconWrap--whatsapp">
                    <IconWA />
                  </div>
                  <div className="elenardContact__contactInfo">
                    <span className="elenardContact__contactLabel">WhatsApp</span>
                    <span className="elenardContact__link">+60 14 622 7288</span>
                  </div>
                </a>
              </div>

              <div className="elenardContact__block">
                <h2 className="elenardContact__copyTitle">Follow Us</h2>
                <ul className="elenardContact__list">
                  <li>
                    <a
                      className="elenardContact__contactRow"
                      href="https://www.instagram.com/elenard_hairjewelry/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <div className="elenardContact__iconWrap elenardContact__iconWrap--instagram">
                        <IconIG />
                      </div>
                      <div className="elenardContact__contactInfo">
                        <span className="elenardContact__contactLabel">Instagram</span>
                        <span className="elenardContact__link">@elenard_hairjewelry</span>
                      </div>
                    </a>
                  </li>
                  <li>
                    <div className="elenardContact__contactRow">
                      <div className="elenardContact__iconWrap elenardContact__iconWrap--tiktok">
                        <IconTT />
                      </div>
                      <div className="elenardContact__contactInfo">
                        <span className="elenardContact__contactLabel">TikTok</span>
                        <span className="elenardContact__contactValue">@elenard_hairjewelry</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="elenardContact__contactRow">
                      <div className="elenardContact__iconWrap elenardContact__iconWrap--pinterest">
                        <IconPIN />
                      </div>
                      <div className="elenardContact__contactInfo">
                        <span className="elenardContact__contactLabel">Pinterest</span>
                        <span className="elenardContact__contactValue">elenard_hairjewelry</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </aside>

          </div>
        </div>
      </div>

    </main>
  );
}
